import {
  IAdminMedicationInquiryDetails,
  IAdminMedicationNeedsMoreInfoPayload,
  IAdminMedicationSubmitPayload,
} from '@interfaces/adminMedications';
import {
  IAdminSupplementCreateNewPayload,
  IAdminSupplementInquiryDetails,
  IAdminSupplementInquiryStatus,
  IAdminSupplementMarkAsMedicationPayload,
  IAdminSupplementMatchExistingPayload,
  IAdminSupplementNeedsMoreInfoPayload,
  IAdminSupplementRenewPayload,
} from '@interfaces/adminSupplements';
import { IFetchListRequestPayload } from '@interfaces/common';
import { IDietarySupplementSearchResult } from '@interfaces/supplements';

import { apiUrls } from './urls';
import { get, post } from './utils';

export const adminSearchSupplements = (payload: IFetchListRequestPayload) =>
  post<IDietarySupplementSearchResult>(apiUrls.adminInquiries.searchSupplements, payload);

export const adminSupplementInquiryDetails = (supplementInquiryId: number) =>
  get<IAdminSupplementInquiryDetails>(
    `${apiUrls.adminInquiries.supplementInquiryDetails}/${supplementInquiryId}`,
  );

export const getAdminSupplementInquiryStatuses = () =>
  get<IAdminSupplementInquiryStatus[]>(apiUrls.lookups.adminSupplementInquiryStatuses);

export const adminCreateNewSupplement = (payload: IAdminSupplementCreateNewPayload) =>
  post(apiUrls.adminInquiries.createNewSupplement, payload);

export const adminSupplementRenew = (payload: IAdminSupplementRenewPayload) =>
  post(apiUrls.adminInquiries.upsertSupplementInquiryResponse, payload);

export const adminSupplementMatchExisting = (payload: IAdminSupplementMatchExistingPayload) =>
  post(apiUrls.adminInquiries.matchExisting, payload);

export const adminSupplementNeedsMoreInfo = (payload: IAdminSupplementNeedsMoreInfoPayload) =>
  post(apiUrls.adminInquiries.needsInfo, payload);

export const adminSupplementMarkAsMedication = (payload: IAdminSupplementMarkAsMedicationPayload) =>
  post(apiUrls.adminInquiries.medicationResponse, payload);

export const adminDeactivateSupplement = (supplementInquiryId: number) =>
  post(apiUrls.adminInquiries.deactivateSupplement, { supplementInquiryId });

export const adminMedicationInquiryDetails = (medicationInquiryId: number) =>
  get<IAdminMedicationInquiryDetails>(
    `${apiUrls.adminInquiries.medicationInquiryDetails}/${medicationInquiryId}`,
  );

export const adminMedicationNeedsMoreInfo = (payload: IAdminMedicationNeedsMoreInfoPayload) =>
  post(apiUrls.adminInquiries.medicationNeedsInfo, payload);

export const adminMedicationSubmit = (payload: IAdminMedicationSubmitPayload) =>
  post(apiUrls.adminInquiries.submitMedication, payload);
